import { Controller } from "stimulus";
import { useMeta } from 'stimulus-use';
import { useMatchMedia } from 'stimulus-use';

export default class extends Controller {
  // TODO 2021-07 move billingDetails and clientSecret to values
  static targets = [
    'billingDetails', 'clientSecret',
    'cardHolderName', 'cardHolderNameLabel',
    'cardNumber', 'cardNumberLabel',
    'cardCvc', 'cardCvcLabel',
    'cardExpiry', 'cardExpiryLabel',
    'form', 'paymentMethod', 'submit', 'submitError',
  ];

  static metaNames = ['stripe'];

  get fieldProperties() {
    return {
      style: {
        base: {
          fontFamily: 'Poppins, sans-serif',
          fontSize: '16px',
          color: '#0F1215',

          '::placeholder': {
            color: '#DBDFE4',
          }
        },

        invalid: {
          color: '#A16718'
        }
      }
    }
  }

  connect() {
    useMeta(this);
    useMatchMedia(this, {
      mediaQueries: {
        md: '(min-width: 768px)',
      }
    })


    this.valid = {
      cardNumber: false, cardCvc: false, cardExpiry: false
    };

    this.labelTexts = {
      cardNumber: this.cardNumberLabelTarget.textContent,
      cardHolderName: this.hasCardHolderNameLabelTarget ? this.cardHolderNameLabelTarget.textContent : '',
      cardCvc: this.cardCvcLabelTarget.textContent,
      cardExpiry: this.cardExpiryLabelTarget.textContent,
    };

    this.stripe = Stripe(this.stripeMeta);
    this.elements = this.stripe.elements({
      fonts: [{
        cssSrc: 'https://fonts.googleapis.com/css?family=Poppins:400&display=swap'
      }]
    });

    this.cardNumber = this.elements.create('cardNumber', {
      'placeholder': 'Enter your card number', ...this.fieldProperties
    });

    this.cardCvc = this.elements.create('cardCvc', this.fieldProperties);
    this.cardExpiry = this.elements.create('cardExpiry', this.fieldProperties);

    this.cardNumber.mount('#card_number');
    this.cardCvc.mount('#card_cvc');
    this.cardExpiry.mount('#card_expiry');

    if (this.hasCardHolderNameTarget) {
      this.cardHolderNameTarget.addEventListener('change', () => {
        this.validateCardHolderName();
      }, false);
    }

    [this.cardNumber, this.cardCvc, this.cardExpiry].forEach(field => {
      field.on('change', event => {
        this.toggleError(event.elementType, event.error);
      });
    });
  }

  isMd() {
    this.element.scrollIntoView();
  }

  validateCardHolderName() {
    if (this.cardHolderNameTarget.value.length === 0) {
      this.toggleError('cardHolderName', {
        message: 'You must provide the name on card'
      });
    } else {
      this.toggleError('cardHolderName');
    }
  }

  toggleError(elementType, error) {
    const label = this[`${elementType}LabelTarget`];
    const container = this[`${elementType}Target`];

    this.valid[elementType] = event.complete && event.error === undefined;
    this.submitTarget.disabled = Object.values(this.valid).some(v => v === false);

    if (error) {
      container.classList.add('border-primary-800', 'bg-primary-400');
      label.classList.add('bg-primary-400');
      label.textContent = error.message;
      label.setAttribute('title', error.message);

    } else {
      container.classList.remove('border-primary-800', 'bg-primary-400');
      label.classList.remove('bg-primary-400');
      label.textContent = this.labelTexts[elementType];
      label.removeAttribute('title');
    }
  }

  async submit() {
    const clientSecret = this.clientSecretTarget.value;
    const billing_details = JSON.parse(this.billingDetailsTarget.value);

    const { setupIntent, error } = await this.stripe.confirmCardSetup(
      clientSecret, { payment_method: { card: this.cardNumber, billing_details } }
    );

    if (error) {
      this.submitErrorTarget.textContent = error.message;

    } else {
      if (setupIntent.status === 'succeeded') {
        this.paymentMethodTarget.value = setupIntent.payment_method;
        this.paymentMethodTarget.form.dispatchEvent(new CustomEvent('submit', {bubbles: true}));
      }
    }
  }

  async retry() {
    const { paymentMethod, error } = await this.stripe.createPaymentMethod({
      type: 'card',
      card: this.cardNumber,
      billing_details: { name: this.cardHolderNameTarget.value }
    });

    if (error) {
      this.submitErrorTarget.textContent = error.message;

    } else {
      this.paymentMethodTarget.value = paymentMethod.id;
      this.paymentMethodTarget.form.dispatchEvent(new CustomEvent('submit', {bubbles: true}));
    }
  }
}
